import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface SmallTextProps {
    title: string;
}

const SmallText = ({ title }: SmallTextProps) => {
    const theme = useTheme();

    return <Typography sx={{ color: theme.palette.grey[400], fontFamily: 'Inter', fontWeight: 500, fontSize: '12px' }}>{title}</Typography>;
};

export default SmallText;
